var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PlusCircleIcon } from "@heroicons/react/24/outline";
import { useContext } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { OPEN_NEW_PIPELINE_MODAL } from "../../../constants";
import { ModalContext } from "../../../providers/ModalContextProvider";
function PipelineIntro() {
    const { modalDispatch } = useContext(ModalContext);
    const openPipelineModal = () => __awaiter(this, void 0, void 0, function* () {
        modalDispatch({
            type: OPEN_NEW_PIPELINE_MODAL,
        });
    });
    return (_jsx("div", { className: "wpqt-flex wpqt-h-screen-minus-top-bar wpqt-items-center wpqt-justify-center", children: _jsxs("div", { onClick: openPipelineModal, className: "wpqt-flex wpqt-cursor-pointer wpqt-items-center wpqt-gap-2", children: [_jsx(PlusCircleIcon, { className: "wpqt-icon-green wpqt-size-6 wpqt-cursor-pointer" }), _jsx("span", { children: __("Add your first Board", "quicktasker") })] }) }));
}
export { PipelineIntro };
